import React from 'react';
import { Box, Typography } from '@material-ui/core';
import styled from 'styled-components';

import { Link } from '../Link';

interface IProps {
    className?: string;
    title?: string;
}

const BaseMessageBox: React.FC<IProps> = ({ children, className, title }) => (
    <Box className={className} p={5}>
        <Box className="messageBoxBackground" />
        <Box position="relative" zIndex={1}>
            <Box mb={1}>
                <Typography className="messageBoxTitle" variant="body2">
                    {title}
                </Typography>
            </Box>

            <Typography component="div" variant="body2">
                {children}
            </Typography>
        </Box>
    </Box>
);

export const MessageBox = styled(BaseMessageBox)`
    position: relative;
    color: ${({ theme }) => theme.palette.primary.main};
    border-radius: 5px;

    .messageBoxBackground {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${({ theme }) => theme.palette.primary.main};
        opacity: 0.1;
        z-index: 0;
    }

    .messageBoxTitle {
        font-weight: 700;
    }

    ${Link} {
        text-decoration: underline;
    }
`;
